/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import styles from './SupplierTooltip.module.scss';
function SupplierTooltip({ data }) {
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("h3", { className: styles.header, title: data.title || '-' }, data.title || '-'),
        React.createElement("div", { className: styles.details },
            React.createElement("label", null, "Typ zamka"),
            React.createElement("p", null, "COD.21"),
            React.createElement("label", null, "Rodzaj g\u00F3rnej maszynki"),
            React.createElement("p", null, "NECK (52CFV)"),
            React.createElement("label", null, "Rodzaj dolnej maszynki"),
            React.createElement("p", null, "0"),
            React.createElement("label", null, "Kod producenta"),
            React.createElement("p", null, "KP-23323FG"))));
}
export default SupplierTooltip;
